(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["club-formule-libre"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(value) {
      return value.toFixed(2).replace('.', ',').replace(',00', '');
    }

    function initRecap(root) {
      if (root.dataset.recapInit === '1') return;
      root.dataset.recapInit = '1';

      var grammes = parseFloat(root.dataset.grammes) || 9;
      var prixKg = parseFloat(root.dataset.prixKg) || 27;
      var bonusM = parseFloat(root.dataset.bonusMensuel) || 5;
      var bonusQ = parseFloat(root.dataset.bonusTrimestriel) || 15;
      var shippingExtra = parseFloat(root.dataset.shippingExtra) || 5;

      var slider = root.querySelector('[data-recap-slider]');
      var cafesEl = root.querySelector('[data-recap-cafes]');
      var paquetsEl = root.querySelector('[data-recap-paquets]');
      var prixEl = root.querySelector('[data-recap-prix]');
      var walletEl = root.querySelector('[data-recap-wallet]');
      var bonusPctEl = root.querySelector('[data-recap-bonus-pct]');
      var shippingEl = root.querySelector('[data-recap-shipping]');
      var shippingRow = root.querySelector('[data-recap-shipping-row]');
      var totalEl = root.querySelector('[data-recap-total]');
      var periodEl = root.querySelector('[data-recap-period]');

      var freqButtons = root.querySelectorAll('[data-freq]');
      var shipButtons = root.querySelectorAll('[data-shipping]');

      var state = {
        cafes: parseInt(slider.value, 10),
        freq: 'monthly',
        shipping: 'mr'
      };

      function setActive(buttons, attr, value) {
        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute(attr) === value);
        });
      }

      function update() {
        var monthsCount = state.freq === 'quarterly' ? 3 : 1;
        var bonus = state.freq === 'quarterly' ? bonusQ : bonusM;

        var grams = state.cafes * grammes * 30;
        var packs = Math.max(1, Math.round(grams / 500));
        var monthly = packs * (prixKg / 2);
        var subtotal = monthly * monthsCount;
        var wallet = subtotal * (1 + bonus / 100);
        var ship = state.shipping === 'col' ? shippingExtra * monthsCount : 0;
        var total = subtotal + ship;

        if (cafesEl) cafesEl.textContent = state.cafes;
        if (paquetsEl) paquetsEl.textContent = (packs * monthsCount) + ' × 500 g';
        if (prixEl) prixEl.textContent = fmt(subtotal);
        if (walletEl) walletEl.textContent = fmt(wallet);
        if (bonusPctEl) bonusPctEl.textContent = bonus;
        if (shippingEl) shippingEl.textContent = fmt(ship);
        if (shippingRow) shippingRow.hidden = state.shipping !== 'col';
        if (totalEl) totalEl.textContent = fmt(total);
        if (periodEl) periodEl.textContent = state.freq === 'quarterly' ? '/ trimestre' : '/ mois';

        var min = parseFloat(slider.min);
        var max = parseFloat(slider.max);
        var pct = ((state.cafes - min) / (max - min)) * 100;
        slider.style.setProperty('--slider-pct', pct + '%');
      }

      slider.addEventListener('input', function () {
        state.cafes = parseInt(slider.value, 10);
        update();
      });

      freqButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.freq = btn.getAttribute('data-freq');
          setActive(freqButtons, 'data-freq', state.freq);
          update();
        });
      });

      shipButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.shipping = btn.getAttribute('data-shipping');
          setActive(shipButtons, 'data-shipping', state.shipping);
          update();
        });
      });

      update();
    }

    function initAll() {
      document.querySelectorAll('[data-club-recap]').forEach(initRecap);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["club-formule-machine"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(value) {
      return value.toFixed(2).replace('.', ',').replace(',00', '');
    }

    function initMachine(root) {
      if (root.dataset.machineInit === '1') return;
      root.dataset.machineInit = '1';

      var grammes = parseFloat(root.dataset.grammes) || 9;
      var prixKg = parseFloat(root.dataset.prixKg) || 27;
      var bonus = parseFloat(root.dataset.bonusMensuel) || 5;
      var machinePrix = parseFloat(root.dataset.machinePrix) || 0;
      var reduction12 = parseFloat(root.dataset.reduction12m) || 0;
      var reduction18 = parseFloat(root.dataset.reduction18m) || 0;

      var slider = root.querySelector('[data-machine-slider]');
      var cafesEl = root.querySelector('[data-machine-cafes]');
      var prixEl = root.querySelector('[data-machine-prix]');
      var walletEl = root.querySelector('[data-machine-wallet]');
      var bonusPctEl = root.querySelector('[data-machine-bonus-pct]');
      var origEl = root.querySelector('[data-machine-original]');
      var finalEl = root.querySelector('[data-machine-final]');
      var savEl = root.querySelector('[data-machine-savings]');
      var engagementButtons = root.querySelectorAll('[data-engagement]');

      var state = {
        cafes: parseInt(slider.value, 10),
        engagement: 12
      };

      function setActive(buttons, attr, value) {
        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute(attr) === String(value));
        });
      }

      function update() {
        var grams = state.cafes * grammes * 30;
        var packs = Math.max(1, Math.round(grams / 500));
        var monthly = packs * (prixKg / 2);
        var wallet = monthly * (1 + bonus / 100);

        var reductionPct = state.engagement === 18 ? reduction18 : reduction12;
        var finalPrice = machinePrix * (1 - reductionPct / 100);
        var savings = machinePrix - finalPrice;

        if (cafesEl) cafesEl.textContent = state.cafes;
        if (prixEl) prixEl.textContent = fmt(monthly);
        if (walletEl) walletEl.textContent = fmt(wallet);
        if (bonusPctEl) bonusPctEl.textContent = bonus;
        if (origEl) origEl.textContent = fmt(machinePrix) + ' €';
        if (finalEl) finalEl.textContent = fmt(finalPrice) + ' €';
        if (savEl) savEl.textContent = fmt(savings) + ' €';

        var min = parseFloat(slider.min);
        var max = parseFloat(slider.max);
        var pct = ((state.cafes - min) / (max - min)) * 100;
        slider.style.setProperty('--slider-pct', pct + '%');
      }

      slider.addEventListener('input', function () {
        state.cafes = parseInt(slider.value, 10);
        update();
      });

      engagementButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.engagement = parseInt(btn.getAttribute('data-engagement'), 10);
          setActive(engagementButtons, 'data-engagement', state.engagement);
          update();
        });
      });

      update();
    }

    function initAll() {
      document.querySelectorAll('[data-club-machine]').forEach(initMachine);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
